import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  .shows-and-movies,
  &.shows-and-movies {
    &__container {
      padding-top: 40px;
      padding-bottom: 40px;

      ${breakpoints.down('xs')} {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }

    &__collection {
      &:not(:first-of-type) {
        padding-top: 20px;

        ${breakpoints.down('xs')} {
          padding-top: 16px;
        }
      }

      &:not(:last-of-type) {
        padding-bottom: 20px;

        ${breakpoints.down('xs')} {
          padding-bottom: 0;
        }
      }
    }

    .filters,
    &__filters {
      &__search {
        .MuiInputBase-root {
          font-size: 1.8rem;
          font-weight: 400;
          padding: 9px 15px;

          .MuiAutocomplete-input {
            padding: 5px 15px 5px 0;
          }
        }

        &__icon {
          color: inherit;
          font-size: 2rem;
          margin-top: 0;
        }
      }

      &__advanced-button {
        border-radius: 4px;

        ${breakpoints.down('xs')} {
          padding: 0;
          border-radius: 50%;
          min-width: 50px;
          max-width: 50px;
          height: 50px;
          font-size: 24px;
        }
      }
    }
  }
`;

export default Wrapper;
